// context/OrderContext.js
import React, { createContext, useContext, useState } from "react";
import {
  fetchOrderDetails,
  addItemToOrder,
  deleteItemFromOrder,
  updateOrderItem,
  moveItemToOtherOrder,
  deleteOrder,
  addOfferToOrder,
  divideTableOrder,
  updateOrder, // ✅ إضافة استيراد دالة تعديل بيانات الأوردر

} from "../../../services/pos/Tables";
import { removeOfferFromOrder } from "../../../services/pos/reservation/reservationApi"; // ✅ استيراد الدالة الجديدة
import { changeOrderItemStatus as changeOrderItemStatusApi } from "../../../services/Settings/Orderprocessing"; // ✅ استيراد الدالة من الخدمات
import { useAuth } from "../../AuthContext"; // عدّل المسار حسب مشروعك

const OrderContext = createContext();


// 🆕 كاش للطلبات
let orderCache = {};
let pendingRequests = {};


export const OrderProvider = ({ children }) => {
    const { isAuthenticated } = useAuth(); // ✅ مهم جدًا

  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // ✅ تحميل الأوردر من السيرفر (مع كاش ومنع التكرار)
//   const loadOrder = async (orderId) => {
//   if (!isAuthenticated ) {
//     console.warn("⛔ loadOrder تم منعه: المستخدم غير مسجل");
//     return;
//   }

//   if (!orderId) return;

//   const branchId = localStorage.getItem("branch_id");
//   if (!branchId) {
//     console.warn("⛔ loadOrder تم منعه: لا يوجد branch_id");
//     return;
//   }

//   // ✅ كاش
//   if (orderCache[orderId]) {
//     setOrderDetails(orderCache[orderId]);
//     return;
//   }

//   if (pendingRequests[orderId]) return;

//   setLoading(true);
//   pendingRequests[orderId] = true;

//   try {
//     const data = await fetchOrderDetails(orderId);
//     orderCache[orderId] = data;
//     setOrderDetails(data);
//     setError(null);
//   } catch (err) {
//     setError(err.message || "❌ فشل في تحميل الطلب");
//   } finally {
//     delete pendingRequests[orderId];
//     setLoading(false);
//   }
// };
const loadOrder = async (orderId, force = false) => {
  if (!isAuthenticated) return;
  if (!orderId) return;

  const branchId = localStorage.getItem("branch_id");
  if (!branchId) return;

  // ✅ لو مش فورس استخدم الكاش
  if (!force && orderCache[orderId]) {
    setOrderDetails(orderCache[orderId]);
    return;
  }

  if (pendingRequests[orderId]) return;

  setLoading(true);
  pendingRequests[orderId] = true;

  try {
    const data = await fetchOrderDetails(orderId);
    orderCache[orderId] = data;
    setOrderDetails(data);
    setError(null);
      return data; // ✅ مهم جدًا

  } catch (err) {
    setError(err.message || "❌ فشل في تحميل الطلب");
  } finally {
    delete pendingRequests[orderId];
    setLoading(false);
  }
};

// تحديث بيانات كروت الديلفري
  const emitOrderUpdated = (orderId) => {
    window.dispatchEvent(
      new CustomEvent("orderUpdated", { detail: { orderId } })
    );

    window.dispatchEvent(
      new CustomEvent("refreshDeliveryOrders", { detail: { orderId } })
    );
  };
  // ✅ إضافة صنف
  // ✅ إضافة صنف
  // const addItem = async (orderId, itemData, productData = {}) => {
  //   try {
  //     const res = await addItemToOrder({
  //       order_id: orderId,
  //       items: [itemData],
  //     });

  //     const serverItem = res?.item || {};

  //     // 👇 نبني العنصر الجديد زي ما UI متوقع
  //     const newItem = {
  //       id: serverItem.id || Date.now(),
  //       order_id: orderId,
  //       product_id: itemData.product_id,
  //       product_name:
  //         productData.name || serverItem.product_name || "منتج بدون اسم",
  //       quantity: itemData.quantity,
  //       price: itemData.price,
  //       total: (itemData.price || 0) * (itemData.quantity || 1), // ✅ احسب الإجمالي
  //       note: itemData.note || "",
  //       status: serverItem.status || itemData.status || "pending",
  //       product_image: productData.image || serverItem.product_image || null, // ✅ نفس اسم المفتاح اللي بيستخدمه UI
  //       description: productData.description || serverItem.description || "",
  //     };

  //     setOrderDetails((prev) => {
  //       const updatedItems = [...(prev?.items || []), newItem];

  //       // ✨ نحسب من كل الأصناف بدل الاعتماد على prev.sub_total
  //       const newSubTotal = updatedItems.reduce(
  //         (sum, i) =>
  //           sum + (parseFloat(i.price) || 0) * (parseFloat(i.quantity) || 1),
  //         0
  //       );

  //       const updated = {
  //         ...prev,
  //         items: updatedItems,
  //         sub_total: newSubTotal,
  //         total: newSubTotal,
  //         details: {
  //           ...(prev?.details || {}),
  //           total: newSubTotal,
  //         },
  //       };

  //       orderCache[orderId] = updated;
  //       return updated;
  //     });

  //     return res;
  //   } catch (err) {
  //     throw new Error(err.message || "❌ فشل في إضافة الصنف");
  //   }
  // };
    const addItem = async (orderId, itemData, productData = {}) => {
    try {
      const res = await addItemToOrder({
        order_id: orderId,
        items: [itemData],
      });

      // ✅ أهم سطرين
      delete orderCache[orderId];
      await loadOrder(orderId);
      emitOrderUpdated(orderId);

      return res;
    } catch (err) {
      throw new Error(err.message || "❌ فشل في إضافة الصنف");
    }
  };

  // ✅ تعديل صنف
  // ✅ تعديل صنف
  // const updateItem = async (updatedData) => {
  //   try {
  //     const payload = {
  //       id: Number(updatedData.id), // 👈 لازم يكون items[].id (زي 94)
  //       quantity: parseInt(updatedData.quantity, 10),
  //       price: parseFloat(updatedData.price) || 0,
  //       note: updatedData.note || "",
  //     };

  //     console.log("📤 Payload للـ API:", payload); // ✅ مهم

  //     const res = await updateOrderItem(payload);
  //     console.log("📥 رد السيرفر بعد التعديل:", res);

  //     setOrderDetails((prev) => {
  //       const updatedItems = prev.items.map((i) =>
  //         i.id === updatedData.id ? { ...i, ...updatedData } : i
  //       );

  //       const newSubTotal = updatedItems.reduce(
  //         (sum, i) =>
  //           sum + (parseFloat(i.price) || 0) * (parseFloat(i.quantity) || 1),
  //         0
  //       );

  //       const updated = {
  //         ...prev,
  //         items: updatedItems,
  //         sub_total: newSubTotal,
  //         total: newSubTotal,
  //         details: {
  //           ...(prev?.details || {}),
  //           total: newSubTotal,
  //         },
  //       };

  //       if (prev?.id) orderCache[prev.id] = updated;
  //       return updated;
  //     });
  //     return res;
  //   } catch (err) {
  //     console.error("❌ خطأ في updateItem:", err);
  //     throw new Error(err.message || "❌ فشل في تعديل الصنف");
  //   }
  // };
  const updateItem = async (updatedData) => {
    try {
      const payload = {
        id: Number(updatedData.id), // 👈 لازم يكون items[].id (زي 94)
        quantity: parseInt(updatedData.quantity, 10),
        price: parseFloat(updatedData.price) || 0,
        note: updatedData.note || "",
      };

      console.log("📤 Payload للـ API:", payload); // ✅ مهم

      const res = await updateOrderItem(payload);
      console.log("📥 رد السيرفر بعد التعديل:", res);

      setOrderDetails((prev) => {
        const updatedItems = prev.items.map((i) =>
          i.id === updatedData.id ? { ...i, ...updatedData } : i
        );

        const newSubTotal = updatedItems.reduce(
          (sum, i) =>
            sum + (parseFloat(i.price) || 0) * (parseFloat(i.quantity) || 1),
          0
        );

        const updated = {
          ...prev,
          items: updatedItems,
          sub_total: newSubTotal,
          total: newSubTotal,
          details: {
            ...(prev?.details || {}),
            total: newSubTotal,
          },
        };

        if (prev?.id) orderCache[prev.id] = updated;
        return updated;
      });
      return res;
    } catch (err) {
      console.error("❌ خطأ في updateItem:", err);
      throw new Error(err.message || "❌ فشل في تعديل الصنف");
    }
  };

  // ✅ حذف صنف
  // const deleteItem = async (itemId) => {
  //   try {
  //     await deleteItemFromOrder(itemId);
  //     // ✅ أهم سطرين

  //     setOrderDetails((prev) => {
  //       const updatedItems = prev.items.filter((i) => i.id !== itemId);

  //       const newSubTotal = updatedItems.reduce(
  //         (sum, i) =>
  //           sum + (parseFloat(i.price) || 0) * (parseFloat(i.quantity) || 1),
  //         0
  //       );

  //       const updated = {
  //         ...prev,
  //         items: updatedItems,
  //         sub_total: newSubTotal,
  //         total: newSubTotal,
  //         details: {
  //           ...(prev?.details || {}),
  //           total: newSubTotal,
  //         },
  //       };

  //       if (prev?.id) orderCache[prev.id] = updated;
  //       return updated;
  //     });
  //   } catch (err) {
  //     throw new Error(err.message || "❌ فشل في حذف الصنف");
  //   }
  // };
  const deleteItem = async (itemId) => {
  try {
    await deleteItemFromOrder(itemId);

    const currentOrderId = orderDetails?.id; // ✅ هنا

    setOrderDetails((prev) => {
      const updatedItems = prev.items.filter((i) => i.id !== itemId);

      const newSubTotal = updatedItems.reduce(
        (sum, i) =>
          sum + (parseFloat(i.price) || 0) * (parseFloat(i.quantity) || 1),
        0
      );

      const updated = {
        ...prev,
        items: updatedItems,
        sub_total: newSubTotal,
        total: newSubTotal,
        details: {
          ...(prev?.details || {}),
          total: newSubTotal,
        },
      };

      if (prev?.id) orderCache[prev.id] = updated;
      return updated;
    });

    // ✅ حدّث كروت الدليفري
    if (currentOrderId) emitOrderUpdated(currentOrderId);

  } catch (err) {
    throw new Error(err.message || "❌ فشل في حذف الصنف");
  }
};


  // ✅ نقل صنف
  const moveItem = async (orderId, data) => {
    try {
      await moveItemToOtherOrder({
        item_id: data.item_id,
        source_order_id: orderId,
        target_table: data.target_table,
        quantity: data.quantity,
      });

      setOrderDetails((prev) => {
        const updated = {
          ...prev,
          items: prev.items.filter((i) => i.id !== data.item_id),
        };
        orderCache[orderId] = updated;
        return updated;
      });
    } catch (err) {
      throw new Error(err.message || "❌ فشل في نقل الصنف");
    }
  };

  // ✅ حذف أوردر
  const removeOrder = async (orderId) => {
    try {
      await deleteOrder(orderId);
      setOrderDetails(null);
      delete orderCache[orderId]; // مسح من الكاش
    } catch (err) {
      throw new Error(err.message || "❌ فشل في حذف الطلب");
    }
  };

  // ✅ إضافة عرض إلى الأوردر (منفذ عبر الـ Context)
  // const addOffer = async ({ offer_id, order_id }) => {
  //   if (!order_id || !offer_id) throw new Error("Missing order_id or offer_id");
  //   try {
  //     const res = await addOfferToOrder({ offer_id, order_id });

  //     // بعد النجاح: نعيد تحميل تفاصيل الأوردر من السيرفر لضمان التزامن مع الكاش
  //     try {
  //       delete orderCache[order_id]; // 🧹 امسح الكاش القديم
  //       await loadOrder(order_id);   // ♻️ أعد تحميل الأوردر من السيرفر
  //     } catch (e) {
  //       console.warn("⚠️ فشل في إعادة تحميل الأوردر بعد إضافة العرض:", e);
  //     }

  //     return res;
  //   } catch (err) {
  //     console.error("❌ فشل في إضافة العرض عبر Context:", err);
  //     throw err;
  //   }
  // };
  const addOffer = async ({ offer_id, order_id }) => {
  if (!order_id || !offer_id) throw new Error("Missing order_id or offer_id");

  try {
    const res = await addOfferToOrder({ offer_id, order_id });

    // ✅ امسح الكاش + هات أحدث بيانات للأوردر
    delete orderCache[order_id];
    await loadOrder(order_id, true);

    // ✅ حدّث كروت الدليفري
    emitOrderUpdated(order_id);

    return res;
  } catch (err) {
    console.error("❌ فشل في إضافة العرض عبر Context:", err);
    throw err;
  }
};

// ✅ تقسيم الطلب (Divide Table Order)
const divideOrder = async (orderId, selectedItems) => {
  try {
    await divideTableOrder(orderId, selectedItems);

    // 🧹 امسح الكاش القديم وأعد تحميل الأوردر لتحديث البيانات
    delete orderCache[orderId];
    await loadOrder(orderId);

    return true;
  } catch (err) {
    console.error("❌ خطأ في تقسيم الأوردر:", err);
    throw new Error(err.message || "❌ فشل في تقسيم الأوردر");
  }
};
// ✅ تعديل بيانات الأوردر (العميل - الطاولة - إلخ)
// const updateOrderData = async (orderId, updateData) => {
//   try {
//     const res = await updateOrder(orderId, updateData);

//     // 🔄 بعد التعديل، حدث الكاش والـ state
//     delete orderCache[orderId];
//     await loadOrder(orderId);

//     return res;
//   } catch (err) {
//     console.error("❌ فشل في تعديل الأوردر:", err);
//     throw new Error(err.message || "❌ لم يتم تعديل الأوردر");
//   }
// };
const updateOrderData = async (orderId, updateData) => {
  try {
    const res = await updateOrder(orderId, updateData);

    // 🔄 بعد التعديل: امسح الكاش + هات أحدث بيانات
    delete orderCache[orderId];
    await loadOrder(orderId, true);

    // ✅ حدّث كروت الدليفري
    emitOrderUpdated(orderId);

    return res;
  } catch (err) {
    console.error("❌ فشل في تعديل الأوردر:", err);
    throw new Error(err.message || "❌ لم يتم تعديل الأوردر");
  }
};


  // ✅ حذف عرض من الأوردر (منفذ عبر الـ Context)
  const removeOffer = async ({ order_id, offer_id }) => {
    if (!order_id || !offer_id) throw new Error("Missing order_id or offer_id");
    try {
      const res = await removeOfferFromOrder(order_id, offer_id);

      // بعد النجاح: نعيد تحميل تفاصيل الأوردر من السيرفر لضمان التزامن مع الكاش
      try {
        delete orderCache[order_id]; // 🧹 امسح الكاش القديم
        await loadOrder(order_id); // ♻️ أعد تحميل الأوردر من السيرفر
        
      } catch (e) {
        console.warn("⚠️ فشل في إعادة تحميل الأوردر بعد حذف العرض:", e);
      }

      return res;
    } catch (err) {
      console.error("❌ فشل في حذف العرض عبر Context:", err);
      throw err;
    }
  };

  // ✅ دالة لتحديث حالة الصنف
  const changeOrderItemStatus = async (itemId, status) => {
    if (!itemId || !status) throw new Error("❌ معرف الصنف أو الحالة مفقود.");
    try {
      // استدعاء API لتحديث حالة الصنف
      await changeOrderItemStatusApi(itemId, status);

      // تحديث حالة الصنف في orderDetails
      setOrderDetails((prev) => {
        const updatedItems = prev.items.map((item) =>
          item.id === itemId ? { ...item, status } : item
        );

        const updatedOrder = {
          ...prev,
          items: updatedItems,
        };

        if (prev?.id) orderCache[prev.id] = updatedOrder; // تحديث الكاش
        return updatedOrder;
      });
    } catch (err) {
      console.error("❌ فشل في تحديث حالة الصنف:", err);
      throw new Error(err.message || "❌ لم يتم تحديث حالة الصنف.");
    }
  };

  return (
    <OrderContext.Provider
      value={{
        orderDetails,
        setOrderDetails,
        loadOrder,
        addItem,
        updateItem,
        deleteOrder,
        deleteItem,
        moveItem,
        removeOrder,
        addOffer, // تصدير دالة الإضافة
        removeOffer, // ✅ تصدير دالة الحذف
        divideOrder,
        updateOrderData,
        loading,
        error,
        changeOrderItemStatus, // ✅ تصدير الدالة الجديدة
      }}
    >
      {children}
    </OrderContext.Provider>
  );
};

export const useOrder = () => useContext(OrderContext);

